// Llamada a Strapi
export const getStrapiData = async (url: string, query: any) => {
  const { locale } = useI18n()
  let content: any
  try {
    const contentData = await $fetch(`/strapi/${locale.value}/${url}`)
    content = extractStrapiData(contentData?.[0])
  } catch (fetchError) {
    console.error('Error llamda de respaldo', fetchError)
  }
  return content
}

export const extractStrapiData = (response: any) => {
  return response?.data
}

export const getStrapiDataBy = async (url: string, by: string, query: any, locale: string) => {
  let content: any
  try {
    const contentData = await $fetch(`/strapi/${locale}/${url}`)
    content = extractStrapiData(contentData?.[0])
  } catch (fetchError) {
    console.error('Error llamda de respaldo', fetchError)
    throw new Error('No se pudo obtener los datos de Strapi')
  }
  return content
}

export const getImageSrc = (strapiData: StrapiData, path: string) => {
  const provider = strapiData?.provider
  const image = strapiData
  if (provider === "s3Provider") {
    return `${path}/${image.name}` // Si es S3, devuelve el nombre
  }

  return image?.url ?? '' // Si es Strapi, usa su URL
}